var actop = actop || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {
 
    $.fn.backToTop = function( options ) {
        return this.each(function() {
            var backToTop = Object.create(actop.backToTop);
            backToTop.init(this, options);
        });
    };

    $.fn.backToTop.options = {
        sectionScroll: false,
        scrollParent: false
     };

    actop.backToTop = {
        
        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            
            if( !self.options.sectionScroll) {
                $(window).scrollTop() >  $(window).height() &&  self.toggle(true);
            }
           
            self.bindElements();
        },

        bindElements () {
            var self = this;
            
            !self.options.sectionScroll && $(window).scroll(function(i) {
                if( $(this).scrollTop() >  $(window).height() ) {
                    self.toggle(true);
                } else {
                    self.toggle(false);
                }
            });

            self.$container.on("click", function() {
                if( self.options.sectionScroll ) {
                    self.scrollParent();
                } else {
                    self.scrollUp();
                }
            });
        },
        toggle(e) {
            var self = this;
            if ( e ) {
                self.$container.addClass("b2t-visible");
            } else {
                self.$container.removeClass("b2t-visible");
            }
        },
        scrollUp() {
            $('html, body').animate({
                    scrollTop: 0
                }, 1000);

        },
        scrollParent() {
            var self = this;

            $('html, body').animate({
                scrollTop: self.$container.closest(self.options.scrollParent).offset().top - 80
            }, 1000);
        }
    };
});
